export default {
  "Bureau": "_Bureau_kw9cu_1",
  "Drawer": "_Drawer_kw9cu_5",
  "Table": "_Table_kw9cu_10",
  "NameCell": "_NameCell_kw9cu_19",
  "ExtraMarginBottom": "_ExtraMarginBottom_kw9cu_23"
};import "ni:sha-256;8PTlxFlSP6CyQfIF4jbBQo6ib5lmLm0pMXln9HKgW-U";